import type { StoryCommit } from "../api/client";
import { ModuleGuide } from "./ModuleGuide";

export function VersionPanel({ commits }: { commits: StoryCommit[] }) {
  return (
    <section className="version-panel" aria-labelledby="version-title">
      <div className="world-heading">
        <p className="eyebrow">Canonical Ledger</p>
        <h1 id="version-title">版本历史</h1>
        <p>每次人工接受都形成不可变提交；草稿和被拒绝的变更不会出现在这里。</p>
      </div>
      <ModuleGuide module="version" />
      <ol className="commit-list">
        {commits.map((commit) => (
          <li key={commit.id}>
            <span className="commit-sequence">C-{String(commit.sequence).padStart(3, "0")}</span>
            <div><strong>{commit.id}</strong><small>{commit.actor_type} · {commit.author_id} · Schema v{commit.schema_version}</small></div>
            <time dateTime={new Date(commit.created_at_ms).toISOString()}>{new Date(commit.created_at_ms).toLocaleString("zh-CN")}</time>
          </li>
        ))}
      </ol>
      {commits.length === 0 ? <p className="empty-state">当前分支还没有提交。</p> : null}
    </section>
  );
}
